var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.499924 0.500169C0.890449 0.109644 1.52361 0.109644 1.91414 0.500169L6.99993 5.58598L12.0857 0.500215C12.4762 0.109691 13.1094 0.109691 13.4999 0.500215C13.8905 0.89074 13.8905 1.52391 13.4999 1.91443L8.41414 7.00019L13.4999 12.086C13.8904 12.4766 13.8904 13.1097 13.4999 13.5002C13.1094 13.8908 12.4762 13.8908 12.0857 13.5002L6.99993 8.4144L1.91414 13.5002C1.52362 13.8907 0.89045 13.8907 0.499925 13.5002C0.109401 13.1097 0.109401 12.4765 0.499925 12.086L5.58572 7.00019L0.499924 1.91438C0.1094 1.52386 0.1094 0.890693 0.499924 0.500169Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.fc92ad425710adec6d4f6e813757dfcd.svg";
export { ForwardRef as ReactComponent };